import { Component, Prop, Vue } from 'vue-property-decorator';

import { Fee } from '@/views/checkout/interfaces';
import { formatCurrency } from '@/core/currency/helpers';
import { CurrencyInfo, ExchangeRate } from '@/core/currency/interfaces';
import ExchangeDetails from '../exchange-details';

@Component({
    components: {
        ExchangeDetails
    }
})
export default class FeeDetails extends Vue {
    @Prop(Object)
    currency: CurrencyInfo;

    @Prop()
    formatPattern: string;

    @Prop({ type: Array, default: () => ([]) })
    fees: Array<Fee>;

    @Prop(Number)
    amount: number;

    @Prop(Object)
    exchangeRate: ExchangeRate;

    @Prop()
    exchangeAmount: string;

    @Prop(Number)
    redeemedAmount: number;

    @Prop(Boolean)
    hasRedemption: boolean;

    formatPrice(price) {
        return formatCurrency(
            (price / 100).toString(),
            this.currency.format,
            this.formatPattern
        );
    }

    exchangeRateFormatFees(price) {
        if (!this.exchangeRate) {
            return null;
        }

        return formatCurrency(
            ((price / 100) * this.exchangeRate?.rate).toFixed(2).toString(),
            this.currency.format,
            this.formatPattern
        );
    }

    get totalAmount() {
        let totalAmount = !this.hasRedemption
            ? this.amount
            : 0;

        if (this.hasRedemption && this.redeemedAmount <= this.amount) {
            totalAmount = this.amount - this.redeemedAmount;
        }

        return formatCurrency(
            totalAmount.toFixed(2),
            this.currency.format,
            this.formatPattern
        );
    }
}
